import { render } from "./ViewWrapperComponent.vue?vue&type=template&id=481a80e9"
import script from "./ViewWrapperComponent.vue?vue&type=script&lang=js"
export * from "./ViewWrapperComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__